import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_daeyv9q8xk: FaireBrandEntity = {
  token: "b_daeyv9q8xk",
  type: "brand",
  name: "Nutra Moment",
  avatarUrl:
    "https://cdn.faire.com/fastly/8b422a5e9cb0aed20cc4accb3effa095f8e140db17a2509d128db7253129a0ae.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1f7c0f796dc557f573003134d5741d5d975b82d6d4d768393337487391e5c283.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8b422a5e9cb0aed20cc4accb3effa095f8e140db17a2509d128db7253129a0ae.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1f7c0f796dc557f573003134d5741d5d975b82d6d4d768393337487391e5c283.png",
  location: "Casper, WY, USA",
  minimumOrderDollars: 35,
  rating: 5,
  reviewCount: 24,
  isTopShop: true,
  isInsider: true,
  description:
    "Helping you live a healthy, more balanced life.\n\nNutra Moment is a superfood-powered supplement company designed with you in mind. Every product we create is made with only science-backed and market-approved ingredients formulated to help you care for your health, wherever you are in the journey.\n\nWhether you're looking to support your overall health or target a specific need or symptom, Nutra Moment has you covered.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:37.441Z",
    importedBy: "entity-db-cli",
  },
};
